import React from 'react';

export default function Twitter({ className }) {
  return (
  <svg
    className={`facebook ${ className }`}
    viewBox="0 0 24 24"
  >
    <path d="M21,3H3v18h9.621v-6.961h-2.343v-2.725h2.343V9.309c0-2.324,1.421-3.591,3.495-3.591c0.699-0.002,1.397,0.034,2.092,0.105 v2.43h-1.428c-1.13,0-1.35,0.534-1.35,1.322v1.735h2.7l-0.351,2.725h-2.365V21H21V3z"/>
  </svg>
  );
}